export const currencies = [
    {label: "Russian Ruble", value: "RUB", },
    {label: "Ukrainian Hryvnia", value: "UAH", },
    {label: "United States Dollar", value: "USD"},
    {label: "European Euro", value: "EUR"},
    {label: "Canadian Dollar", value: "CAD"},
    {label: "Indonesian Rupiah", value: "IDR"},
    {label: "Polish Zloty", value: "PLN"},
]
